// extracted by mini-css-extract-plugin
export default {"ownerLogo":"IGYxTlRB8TJvPRAWaK9o","avatar":"ZtHPlUV6O2qHCgIsrivC","organizedBy":"apNjOkfku5qDS_f0PSJv","topicTag":"veq5wzqLCcMN2ajcOXNr","ownerName":"IKJXrVNVMPm8gXUDgKft"};